import "./style.css";

export default class Header {
  static selector = ".header";

  constructor(block) {
    this.block = block;

    this.hamburger = this.block.querySelector(".hamburger");
    this.menu = this.block.querySelector(".header__menu");

    this.header = document.querySelector(".header");

    this.doc = document.documentElement;
    this.w = window;

    this.prevScroll = this.w.scrollY || this.doc.scrollTop;
    this.curScroll;
    this.direction = 0;
    this.prevDirection = 0;

    this.init();

    window.addEventListener("scroll", this.onScroll);
  }

  hamburgerToggle = (e, force) => {
    this.hamburger.classList.toggle("is-active", force);
    this.menu.classList.toggle(
      "is-active",
      this.hamburger.classList.contains("is-active")
    );
  };

  init = () => {
    this.hamburger.addEventListener("click", this.hamburgerToggle);
  };

  // Public methods
  onResize(e, { changedView }) {
    if (changedView && window.App.getCurrentView() !== "mobile") {
      this.hamburgerToggle(null, false);
    }
  }

  onScroll = () => {
    this.curScroll = this.w.scrollY || this.doc.scrollTop;
    if (this.curScroll > this.prevScroll) {
      //scrolling up
      this.direction = 2;
    } else if (this.curScroll < this.prevScroll) {
      //scrolling down
      this.direction = 1;
    }

    if (this.direction !== this.prevDirection) {
      this.toggleHeader(this.direction, this.curScroll);
    }

    this.prevScroll = this.curScroll;
  };

  toggleHeader = (direction, curScroll) => {
    if (direction === 2 && curScroll > 73) {
      this.header.classList.add("hide");
      this.prevDirection = direction;
    } else if (direction === 1) {
      this.header.classList.remove("hide");
      this.prevDirection = direction;
    }
  };
}
